import React, { useState } from 'react';
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from '../config/firebase';
import { GoogleIcon } from './Icons';

const LoginScreen = ({ setLoginError, loginError }) => {
    const [loading, setLoading] = useState(false);

    const handleLogin = async () => {
        setLoginError('');
        setLoading(true);

        // Se admite cualquier cuenta de Google: el personal interno entra con la de
        // @axoncapital y un productor puede usar otra (p. ej. Gmail). Qué ve cada uno
        // lo decide App con el padrón de productores, y lo imponen las reglas de
        // Firestore y las Cloud Functions; una cuenta externa que no figura se cierra.
        try {
            await signInWithPopup(auth, provider);
        } catch (error) {
            console.error("Error durante el inicio de sesión:", error);
            if (error.code !== 'auth/popup-closed-by-user') {
                setLoginError(error.message || "El inicio de sesión fue cancelado o ha ocurrido un error.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            zIndex: 50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #1A283E, #0D1A29)',
        }}>
            <div style={{
                background: '#ffffff',
                borderRadius: '16px',
                padding: '2rem',
                width: '100%',
                maxWidth: '28rem',
                margin: '0 1rem',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.4)',
            }}>
                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                    <img
                        src="/logo-axon.png"
                        alt="Axon Capital"
                        style={{ height: '64px', width: 'auto', margin: '0 auto 1rem', display: 'block', objectFit: 'contain' }}
                    />
                    <h1 style={{
                        fontFamily: "'Raleway', sans-serif",
                        fontWeight: 700,
                        fontSize: '1.5rem',
                        color: '#1A283E',
                        marginBottom: '0.25rem',
                    }}>
                        Planilla de Operaciones
                    </h1>
                    <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                        Acceso para el equipo y los productores de axon capital
                    </p>
                </div>

                <div>
                    <button
                        onClick={handleLogin}
                        disabled={loading}
                        style={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.75rem',
                            background: '#ffffff',
                            border: '2px solid #d1d5db',
                            borderRadius: '8px',
                            padding: '0.75rem 1rem',
                            fontSize: '1rem',
                            fontWeight: 500,
                            color: '#374151',
                            cursor: loading ? 'wait' : 'pointer',
                            transition: 'all 0.3s ease',
                            opacity: loading ? 0.7 : 1,
                        }}
                        onMouseEnter={(e) => { e.target.style.borderColor = '#9ca3af'; e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; }}
                        onMouseLeave={(e) => { e.target.style.borderColor = '#d1d5db'; e.target.style.boxShadow = 'none'; }}
                    >
                        <GoogleIcon />
                        Iniciar sesión con Google
                    </button>

                    {loginError && (
                        <div style={{
                            marginTop: '1rem',
                            background: '#fef2f2',
                            border: '1px solid #fca5a5',
                            color: '#991b1b',
                            padding: '0.75rem 1rem',
                            borderRadius: '8px',
                            fontSize: '0.875rem',
                        }}>
                            <p style={{ fontWeight: 600 }}>Acceso denegado</p>
                            <p>{loginError}</p>
                        </div>
                    )}

                    {loading && (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
                            <div style={{
                                width: '2rem',
                                height: '2rem',
                                border: '2px solid #e5e7eb',
                                borderTopColor: '#1A283E',
                                borderRadius: '50%',
                                animation: 'spin 0.6s linear infinite',
                            }} />
                            <span style={{ marginLeft: '0.75rem', color: '#1A283E' }}>Verificando acceso...</span>
                        </div>
                    )}
                </div>

                <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                    <p style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
                        Solo pueden ingresar usuarios autorizados por axon capital
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LoginScreen;